const content = [
    {
      id:1,
      title: "How to connect with Realopinions’ Team ?",
      content:
      "You can mail us at “info@realopinions.io “to get in touch with our team regarding any queries.        ",
    },
    {
      id:2,
      title: "How to integrate Real opinion ?",
      content:
        "The integration of Realopinion is very easy and require 2-3 steps, you can follow the integration document and plug the surveywall into your app instantly.        ",
    },
    
    {
      id:3,
      title: " How to contact our user support ?",
      content:
        "If you are a user and have any query regarding the support, write a mail at info@realopinions.ai.",
    },
   
  ];

  export default content